import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { pageSectionIcons } from "@/components/common/page-section/page-section-icons";

export const PageSection = ({
  children,
  show = true,
  heading = null,
  headingAdditions,
  type = undefined,
  className = "",
  headingClassName,
}: {
  children: ReactNode;
  show?: boolean;
  heading?: any;
  headingAdditions?: any;
  type?: keyof typeof pageSectionIcons;
  className?: string;
  headingClassName?: string;
}) => {
  if (!show) return <></>;

  return (
    <div className={cn(`no-print my-8 xl:my-12`, className)}>
      {heading && (
        <Heading
          icon={type ? pageSectionIcons[type] : null}
          additions={headingAdditions}
          className={headingClassName}
        >
          {heading}
        </Heading>
      )}
      <div>{children}</div>
    </div>
  );
};

const Heading = ({
  children,
  icon,
  additions,
  className = "",
}: {
  children: ReactNode;
  icon?: ReactNode;
  additions?: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "my-6 flex flex-wrap items-center justify-between gap-4",
        className,
      )}
    >
      <div className={"flex items-center gap-2.5"}>
        {icon}
        <span
          className={
            "[&_a]:text-remedium-blue-hover mt-4 text-lg leading-7 font-semibold text-black sm:mt-0"
          }
        >
          {children}
        </span>
      </div>
      {additions && <div className={"w-full md:w-auto"}>{additions}</div>}
    </div>
  );
};
